import { Action } from '../Action'

export const FilterAction = Action.Root
